import React, { useState } from 'react';
import Icon from 'components/AppIcon';
import { ACCESS_LEVELS, FILE_TYPE_CONFIG } from './dataRoomData';

export default function DocumentRow({ doc, userRole, onPreview, onDownload, onViewHistory, onManageAccess, onDelete }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const fileConfig = FILE_TYPE_CONFIG?.[doc?.fileType] || FILE_TYPE_CONFIG?.pdf;
  const accessConfig = ACCESS_LEVELS?.[doc?.accessLevel] || ACCESS_LEVELS?.internal;

  const canManageAccess = userRole === 'admin';
  const canDelete = userRole === 'admin';

  return (
    <tr className="border-b border-border hover:bg-muted/40 transition-colors duration-150 group">
      {/* File Icon + Name */}
      <td className="px-4 py-3">
        <div className="flex items-center gap-3">
          <div
            className="flex items-center justify-center w-8 h-8 rounded-lg flex-shrink-0"
            style={{ background: fileConfig?.bg }}
          >
            <Icon name={fileConfig?.icon} size={16} color={fileConfig?.color} strokeWidth={2} />
          </div>
          <div className="min-w-0">
            <button
              onClick={() => onPreview(doc)}
              className="font-caption text-sm font-semibold text-foreground hover:text-primary transition-colors duration-200 text-left truncate max-w-xs block"
            >
              {doc?.name}
            </button>
            <span className="text-xs font-caption uppercase font-bold" style={{ color: fileConfig?.color }}>
              {doc?.fileType}
            </span>
          </div>
        </div>
      </td>
      {/* Category */}
      <td className="px-4 py-3">
        <span className="text-xs px-2 py-0.5 rounded-md bg-muted text-muted-foreground font-caption capitalize whitespace-nowrap">
          {doc?.category?.replace('-', ' ')}
        </span>
      </td>
      {/* Version */}
      <td className="px-4 py-3">
        <span className="text-xs px-2 py-0.5 rounded-md bg-primary/10 text-primary font-caption font-semibold">
          {doc?.version}
        </span>
      </td>
      {/* Modified */}
      <td className="px-4 py-3">
        <div className="flex flex-col">
          <span className="text-xs font-caption text-foreground">{doc?.modifiedDate}</span>
          <span className="text-xs font-caption text-muted-foreground">{doc?.modifiedBy}</span>
        </div>
      </td>
      {/* Size */}
      <td className="px-4 py-3">
        <span className="text-xs font-caption text-muted-foreground">{doc?.fileSize}</span>
      </td>
      {/* Access Level */}
      <td className="px-4 py-3">
        <span
          className="text-xs font-semibold px-2 py-0.5 rounded-full font-caption border whitespace-nowrap"
          style={{ color: accessConfig?.color, background: accessConfig?.bg, borderColor: accessConfig?.border }}
        >
          {accessConfig?.label}
        </span>
      </td>
      {/* Actions */}
      <td className="px-4 py-3">
        <div className="flex items-center gap-1">
          <button
            onClick={() => onPreview(doc)}
            className="flex items-center justify-center w-7 h-7 rounded-md text-muted-foreground hover:text-primary hover:bg-primary/10 transition-all duration-200"
            title="Preview"
          >
            <Icon name="Eye" size={14} />
          </button>
          <button
            onClick={() => onDownload(doc)}
            className="flex items-center justify-center w-7 h-7 rounded-md text-muted-foreground hover:text-primary hover:bg-primary/10 transition-all duration-200"
            title="Download"
          >
            <Icon name="Download" size={14} />
          </button>
          <div className="relative">
            <button
              onClick={() => setMenuOpen((p) => !p)}
              className="flex items-center justify-center w-7 h-7 rounded-md text-muted-foreground hover:text-foreground hover:bg-muted transition-all duration-200"
              title="More options"
            >
              <Icon name="MoreHorizontal" size={14} />
            </button>
            {menuOpen && (
              <div
                className="absolute right-0 top-full mt-1 w-44 bg-popover border border-border rounded-lg shadow-lg py-1"
                style={{ zIndex: 50 }}
                onMouseLeave={() => setMenuOpen(false)}
              >
                <button
                  onClick={() => { onViewHistory(doc); setMenuOpen(false); }}
                  className="w-full flex items-center gap-2.5 px-3 py-2 text-sm font-caption text-foreground hover:bg-muted transition-colors duration-150"
                >
                  <Icon name="History" size={14} /> View History
                </button>
                {canManageAccess && (
                  <button
                    onClick={() => { onManageAccess(doc); setMenuOpen(false); }}
                    className="w-full flex items-center gap-2.5 px-3 py-2 text-sm font-caption text-foreground hover:bg-muted transition-colors duration-150"
                  >
                    <Icon name="Users" size={14} /> Manage Access
                  </button>
                )}
                <button
                  className="w-full flex items-center gap-2.5 px-3 py-2 text-sm font-caption text-foreground hover:bg-muted transition-colors duration-150"
                  onClick={() => setMenuOpen(false)}
                >
                  <Icon name="Pencil" size={14} /> Rename
                </button>
                {canDelete && (
                  <>
                    <div className="my-1 border-t border-border" />
                    <button
                      onClick={() => { onDelete(doc); setMenuOpen(false); }}
                      className="w-full flex items-center gap-2.5 px-3 py-2 text-sm font-caption text-error hover:bg-error/10 transition-colors duration-150"
                    >
                      <Icon name="Trash2" size={14} /> Delete
                    </button>
                  </>
                )}
              </div>
            )}
          </div>
        </div>
      </td>
    </tr>
  );
}
